import ThemeConfig from '../theme-config';

const themeConfig: ThemeConfig = {
  data: {
    url: 'https://jobs.wienerstadtwerke.at/jobPublication/list.json',
    fieldsSmall: true,
    maxCacheAge: '3600',
  },
  ui: {
    theme: undefined,
    showLabels: true,
    jobsPerPage: 4,
  },
  cardContent: {
    workingTimes: { enabled: true },
  },
  filters: {
    keywords: { enabled: true, order: -10 },
    categories: { enabled: true, order: -9 },
    locations: { enabled: false },
    targetGroups: { enabled: true, order: -8 },
    companies: { enabled: false, order: -7 },
  },
  styles: {
    brandColor: '#000050',
    textColor: '#535353',
    fontSize: '14px',
    fontFamily: '"Avenir LT", "Avenir LT W01 55 Roman", Arial, Helvetica, sans-serif',
    borderRadius: '4px',
    headlineStyle: {
      fontSize: '16px',
      fontWeight: 700,
    },
    labelStyle: {
      fontSize: '15px',
    },
  },
  i18n: {
    messages: {
      de: {
        Keywords: 'Suchbegriff(e) eingeben',
        Categories: 'Kategorie(n) wählen',
        Companies: 'Unternehmen wählen',
        'Target Groups': 'Karrierelevel wählen',
        More: 'Mehr anzeigen',
      },
    },
  },
};

export default themeConfig;
